import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import SiteHeader from '@/components/landing/site-header'
import SiteFooter from '@/components/landing/site-footer'

export const Layout: FC<LayoutProps> = ({ children, settings, brands }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main'
                className='sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:bg-primary focus:px-4 focus:py-3 focus:text-primary-foreground'
            >
                Skip to content
            </a>

            <SiteHeader settings={settings} />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <SiteFooter settings={settings} brands={brands} />
        </div>
    )
}
